<form id="card-form" class="col col-lg-3 m-auto" [formGroup]="cardForm" (ngSubmit)="submit()">
    <div class="row g-0 my-1">
        <h1>Login</h1>
    </div>

    <div class="row g-0 my-1">
        <input type="text" class="form-control" placeholder="Username" formControlName="userName">
    </div>

    <div class="row g-0 my-1">
        <input type="text" class="form-control" placeholder="Password" formControlName="password">
    </div>

    <div class="row g-0 my-1">
        <button class="btn btn-primary" type="submit" [disabled]="!cardForm.valid">Submit</button>
    </div>

    <div class="row g-0 my-1">
        <h6>Register for an account <a href="/register">here</a>.</h6>
    </div>
</form>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
